import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LinkLogin from './views/LinkLogin.vue'
import SignUp from './views/Signup.vue'
import Logout from './views/Logout.vue'

import LocManager from './views/LocManager.vue'
import AddEditLocation from './views/AddEditLocation.vue'
import ViewLocation from './views/ViewLocation.vue'

import AdminMenu from './views/AdminMenu.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/admin',
      name: 'AdminMenu',
      component: AdminMenu
    },
    {
      path: '/addeditlocation',
      name: 'AddEditLocation',
      component: AddEditLocation
    },
    {
      path: '/viewlocation',
      name: 'ViewLocation',
      component: ViewLocation
    },
    {
      path: '/locmanager',
      name: 'LocManager',
      component: LocManager
    },
    {
      path: '/login',
      name: 'login',
      component: LinkLogin
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
